import { useState } from 'react';
import axios from 'axios';
import QRCode from 'react-qr-code';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const QRDebug = () => {
  const [qrToTest, setQrToTest] = useState('');
  const [testResult, setTestResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleTest = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const response = await axios.post(`${API}/visitors/validate`, {
        qr_code: qrToTest.trim(),
        scanned_by: 'Debug Test'
      });
      
      setTestResult(response.data);
    } catch (error) {
      setTestResult({
        success: false,
        message: `Error: ${error.message}`,
        error: true
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
      <h1>🔍 Debug QR Codes</h1>
      
      <div style={{ background: '#f7fafc', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem' }}>
        <h2>Test QR Code</h2>
        <form onSubmit={handleTest}>
          <input
            type="text"
            value={qrToTest}
            onChange={(e) => setQrToTest(e.target.value)}
            placeholder="Pega el código QR UUID aquí"
            style={{
              width: '100%',
              padding: '0.75rem',
              fontSize: '1rem',
              border: '2px solid #cbd5e0',
              borderRadius: '8px',
              marginBottom: '1rem'
            }}
          />
          <button
            type="submit"
            disabled={loading || !qrToTest.trim()}
            style={{
              padding: '0.75rem 2rem',
              background: '#667eea',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '1rem',
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? 'Probando...' : 'Probar QR'}
          </button>
        </form>

        {testResult && (
          <div style={{
            marginTop: '1.5rem',
            padding: '1rem',
            background: testResult.success ? '#d1fae5' : '#fee2e2',
            border: `2px solid ${testResult.success ? '#065f46' : '#991b1b'}`,
            borderRadius: '8px'
          }}>
            <h3>{testResult.success ? '✅ Válido' : '❌ Inválido'}</h3>
            <p><strong>Mensaje:</strong> {testResult.message}</p>
            {testResult.visitor && (
              <div style={{ marginTop: '1rem' }}>
                <p><strong>Nombre:</strong> {testResult.visitor.name}</p>
                <p><strong>Status:</strong> {testResult.visitor.status}</p>
                <p><strong>QR Code:</strong> {testResult.visitor.qr_code}</p>
              </div>
            )}
          </div>
        )}
      </div>

      {qrToTest.trim() && (
        <div style={{ background: '#fff', padding: '1.5rem', borderRadius: '8px', textAlign: 'center' }}>
          <h3>Vista del QR</h3>
          <p style={{ fontSize: '0.875rem', color: '#666', marginBottom: '1rem' }}>
            Escanea este QR con tu móvil
          </p>
          <div style={{ display: 'inline-block', padding: '1rem', background: 'white' }}>
            <QRCode value={qrToTest.trim()} size={256} />
          </div>
          <p style={{ fontSize: '0.75rem', color: '#666', marginTop: '1rem', wordBreak: 'break-all' }}>
            Valor: {qrToTest.trim()}
          </p>
        </div>
      )}
    </div>
  );
};

export default QRDebug;
